import { IStory} from "../type";
import { getAuthHeaders } from "../utils/authToken";
import { apiFetch } from "../utils/apiFetch";

export type TCurrentStorysResponse = {
  type: "success";
  stories: IStory[];
};

export type TViewedStoryResponse = {
  type: "success";
}

export async function getCurrentStorys(): Promise<TCurrentStorysResponse> {
    const prom = new Promise<TCurrentStorysResponse>((res) => {
      apiFetch("/miniapi/get_current_storys", {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({}),
        credentials: "include",
      })
        .then((r) => {
          if (!r.ok) {
            // Если ошибка (404, 500 и т.д.), возвращаем пустой массив
            return [];
          }
          return r.json();
        })
        .then((r) => {
          // Проверяем, что r - массив, иначе возвращаем пустой массив
          if (Array.isArray(r)) {
            res({ type: "success", stories: r as IStory[] });
          } else {
            // Если ответ не массив (например, { response: "user not found" }), возвращаем пустой массив
            res({ type: "success", stories: [] });
          }
        })
        .catch((error) => {
          console.error("Error fetching stories:", error);
          res({ type: "success", stories: [] });
        });
    });
  
    return await prom;
  }

  //view_story
  export async function viewedStory(user_id: number, story_id: number): Promise<TViewedStoryResponse> {
    // const tg_id = localStorage.getItem("tg_id");
    const prom = new Promise<TViewedStoryResponse>((res) => {
      apiFetch("/miniapi/view_story", {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ user_id: user_id, story_id: story_id }),
        credentials: "include",
      })
        .then((r) => {
          return r.json();
        })
        .then((r) => {  
          res({ type: "success"});
        });
    });
  
    return await prom;
  }
